class ProductCarouselTabs extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.ensureLiveRegion()
    this.syncA11yState()
  }

  setupListeners () {
    super.setupListeners()

    this.handleTabChange = this.handleTabChange.bind(this)

    this.els.trigger?.elements.forEach((triggerEl) => {
      this.listeners.add(triggerEl, 'click', this.handleTabChange)
    })
  }

  handleTabChange (event) {
    const clickedTrigger = event.currentTarget

    this.els.trigger?.elements?.forEach((triggerEl) => {
      const isActive = triggerEl.dataset.index === clickedTrigger.dataset.index

      triggerEl.setAttribute('aria-selected', String(isActive))
      triggerEl.setAttribute('tabindex', isActive ? '0' : '-1')
    })

    this.els.link?.elements.forEach((linkEl) => {
      linkEl.setAttribute(
        'aria-hidden',
        linkEl.dataset.index !== clickedTrigger.dataset.index,
      )
    })

    this.els.panel?.elements.forEach((panelEl) => {
      const isActive = panelEl.dataset.index === clickedTrigger.dataset.index

      panelEl.setAttribute('aria-hidden', String(!isActive))
      panelEl.setAttribute('tabindex', isActive ? '0' : '-1')
    })

    this.announceSelection(clickedTrigger)
  }

  syncA11yState () {
    this.els.trigger?.elements?.forEach((triggerEl) => {
      const isActive = triggerEl.getAttribute('aria-selected') === 'true'
      triggerEl.setAttribute('tabindex', isActive ? '0' : '-1')
    })

    this.els.panel?.elements?.forEach((panelEl) => {
      const isHidden = panelEl.getAttribute('aria-hidden') === 'true'
      panelEl.setAttribute('tabindex', isHidden ? '-1' : '0')
    })
  }

  ensureLiveRegion () {
    if (this.liveRegion) {
      return
    }

    const existingLiveRegion = this.querySelector(
      '[data-product-carousel-tabs-el="live-region"]',
    )

    if (existingLiveRegion) {
      this.liveRegion = existingLiveRegion
      return
    }

    const liveRegion = document.createElement('span')
    liveRegion.className = 'util-ScreenReaderOnly'
    liveRegion.setAttribute('role', 'status')
    liveRegion.setAttribute('aria-live', 'polite')
    liveRegion.setAttribute('aria-atomic', 'true')
    liveRegion.setAttribute('data-product-carousel-tabs-el', 'live-region')

    this.appendChild(liveRegion)
    this.liveRegion = liveRegion
  }

  announceSelection (triggerEl) {
    if (!this.liveRegion || !triggerEl) {
      return
    }

    const tabLabel = (triggerEl.textContent || '').trim()
    if (!tabLabel) {
      return
    }

    const message = `Selected tab ${tabLabel}`

    if (this.liveRegion.textContent === message) {
      this.liveRegion.textContent = ''
    }

    this.liveRegion.textContent = message
  }
}

if (!customElements.get('product-carousel-tabs')) {
  customElements.define('product-carousel-tabs', ProductCarouselTabs)
}
